import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { makeGetRequest } from '../services/httpHelper';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';


const Section = styled.section`
  padding: 60px 0;
`;

const StyledCard = styled(Card)`
  border: none;
  box-shadow: 0 0 15px rgba(0,0,0,0.05);
  transition: 0.3s;
  height: 100%;

  &:hover {
    transform: translateY(-5px);
  }
`;

const TextSermonList = () => {
  const [sermons, setSermons] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      const church = JSON.parse(localStorage.getItem('church'));
      const res = await makeGetRequest(`text-sermons/${church.id}`);
      console.log(res.data)
      if (res?.data) setSermons(res.data);
    })();
  }, []);

  return (
    <Section>
      <Container>
        <h2 className="text-center mb-5">All Text Sermons</h2>
        <Row>
          {sermons.map((sermon) => (
            <Col md={4} sm={6} key={sermon.id} className="mb-4">
              <StyledCard onClick={() => navigate(`/sermons/text/${sermon.id}`)} style={{ cursor: 'pointer' }}>
                <Card.Body>
                  <Card.Title>{sermon.title}</Card.Title>
                  <Card.Text><strong>{sermon.speaker}</strong></Card.Text>
                  <Card.Text><small>{new Date(sermon.date).toLocaleDateString()}</small></Card.Text>
                </Card.Body>
              </StyledCard>
            </Col>
          ))}
        </Row>
      </Container>
    </Section>
  );
};

export default TextSermonList;
